import React from 'react'

function Navigation({username}) {
  return (
    <div>hi {username}</div>
  )
}

export default Navigation